"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SyncPrivateMemosButton = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var React = __importStar(require("react"));
var semantic_ui_react_1 = require("semantic-ui-react");
var i18n_1 = __importDefault(require("../i18n"));
var util_1 = require("../util");
var SyncPrivateMemosButton = function (_a) {
    var syncPrivateMemo = _a.syncPrivateMemo, setSyncPrivateMemo = _a.setSyncPrivateMemo, onlineFriends = _a.onlineFriends, offlineFriends = _a.offlineFriends, favoriteFriends = _a.favoriteFriends, syncingPrivateMemoUserModel = _a.syncingPrivateMemoUserModel;
    var count = React.useMemo(function () {
        return __spreadArray([onlineFriends, offlineFriends], favoriteFriends, true).map(function (users) { return users.filter(util_1.isNotPrivateMemoSyncedAndCanAutoSync); })
            .reduce(function (cnt, users) { return cnt + users.length; }, 0);
    }, [onlineFriends, offlineFriends, favoriteFriends]);
    return ((0, jsx_runtime_1.jsx)(semantic_ui_react_1.Popup, { content: i18n_1.default.syncPrivateMemoDescription, trigger: (0, jsx_runtime_1.jsxs)(semantic_ui_react_1.Button, { color: "orange", onClick: function () { return setSyncPrivateMemo(true); }, disabled: syncPrivateMemo || !!syncingPrivateMemoUserModel || count === 0, children: [syncPrivateMemo ? i18n_1.default.syncingPrivateMemo : count ? i18n_1.default.syncPrivateMemo : i18n_1.default.syncPrivateMemoMustManual, syncPrivateMemo && "".concat(count)] }) }));
};
exports.SyncPrivateMemosButton = SyncPrivateMemosButton;
